import React from "react";

const FocusCall = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.1663 22.0624L23.8154 21.7062C23.5247 21.4111 23.0534 21.4111 22.7627 21.7062L16.1809 28.3875C15.8903 28.6826 15.8903 29.161 16.1809 29.4561L16.5318 29.8123C16.8225 30.1074 17.2938 30.1074 17.5845 29.8123L24.1663 23.131C24.457 22.8359 24.457 22.3574 24.1663 22.0624Z"
        fill="#D30000"
      />
      <path
        d="M23.4138 29.7587L23.7647 29.4025C24.0554 29.1074 24.0554 28.629 23.7647 28.3339L17.2506 21.7213C16.9599 21.4262 16.4886 21.4262 16.1979 21.7213L15.8471 22.0775C15.5564 22.3726 15.5564 22.851 15.8471 23.1461L22.3611 29.7587C22.6518 30.0537 23.1231 30.0537 23.4138 29.7587Z"
        fill="#D30000"
      />
      <path
        d="M33 19.0082C33 6.99708 7 6.99738 7 19.0084C7 19.9724 8.06958 19.9971 9 19.9971H11C11.9549 19.9971 12.9298 20.0206 12.9298 19.0313C12.9298 18.042 12.0175 17.6136 12.0175 17.6136C12.0475 11.8656 28.4679 11.8824 28.4386 17.6138C28.4386 17.6138 27.5263 18.019 27.5263 19.0083C27.5263 19.9976 28.0451 19.9976 29 19.9976H31C31.9549 19.9976 33 19.9974 33 19.0082Z"
        fill="#D30000"
      />
    </svg>
  );
};

export default FocusCall;
